import { SetData } from '~/domain/usecases/dataPagination/redux/SetData';

import { ReduxSetData } from '~/data/store/reducer/dataPagination/usecases/ReduxDataPagination';

export const makeReduxDataPagination = (): SetData => new ReduxSetData();
